import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import Grid from '@mui/material/Grid';
import AgyleDialog from '../../../../../components/modal/agyleDialog';
import AgyleTextField from '../../../../../components/ui/fields/agyleTextField';

const AddPropertyCommentDialog = (props) => {
    const {t} = useTranslation();

    const key = Object.entries(props.data.propertyList).find(([key, value]) =>
        key === props.index ? value : null,
    );
    const initialValue = key && key.length > 1 ? key[1].comment : '';
    const [commentState, setCommentState] = useState(initialValue || '');

    return (
        <AgyleDialog
            title={t('Add Comment')}
            open={props.open}
            onClose={props.onClose}
            onSave={() => {
                props.addComment(commentState);
                props.onClose();
            }}
            width="sm"
            fullWidth
        >
            <>
                <Grid item xs={12}>
                    <AgyleTextField
                        fullWidth
                        multiline
                        placeholder={t('Add Comment')}
                        value={commentState}
                        onChange={(e) => setCommentState(e.target.value)}
                        debounce
                    />
                </Grid>
            </>
        </AgyleDialog>
    );
};

export default AddPropertyCommentDialog;